import { Injectable } from '@angular/core';
import {HttpClient}from '@angular/common/http';
import { Observable } from 'rxjs';
import{Da5610Class}from '../../Class/da5610/da5610-class'
import {environment} from '../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class Da5610Service {

  baseUrl: string=environment.baseUrl + 'da5610/';
  
  constructor(private http:HttpClient) { }

GetCommonControlNames(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetCommonControlNames/'+id);
}

GetControlNames():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetControlNames');
}

//Load saved data in to find section
LoadControls():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'LoadControls');
}

//Select an entry from find section
EmployeeCurrency(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'EmployeeCurrency/'+id);
}

GenerateSchedule(duration,startdt,scheduleamount):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GenerateSchedule/'+duration+'&'+startdt+'&'+scheduleamount);
 
}

GetExchangeRate(FkBaseCurrId,FkTranCurrId,TransactionDate):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetExchangeRate/'+FkBaseCurrId+'&'+FkTranCurrId+'&'+TransactionDate);
}

//Load saved data in to find section
LoadFind():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'LoadFind');
}

//Select an entry from find section
DoFind(Da5610Class:Da5610Class):Observable<any>
{
  return this.http.post<any>(this.baseUrl+'doFind',Da5610Class);
}

//Add or Edit an entry
Create(sundry_class:Da5610Class): Observable<any>
{
  return this.http.post<any>(this.baseUrl+'Create',sundry_class);
}

//Delete an entry
Delete(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'Delete/'+id);
}

//Report
Report(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'Report/'+id);
}
CreateUpload(Sundry_classList:Array<Da5610Class>): Observable<any>
{
  return this.http.post<any>(this.baseUrl+'CreateUpload',Sundry_classList);
}


}
